
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import { ScorecardEntity } from '@/entities/scorecard'
import { getOrdinal } from '@/utils/number'
import { TsNpsSummaryEntity } from '@/entities/teamscoreboard'
import fname from '@/utils/string'
import ScorecardRankRow from '@/components/Scorecard/ScorecardRankRow.vue'
import { ILeaderboardResult, INPSSummary } from '@/entities'

@Component<ScorecardLeaderboard>({
    components: { ScorecardRankRow },
    filters: {
        getOrdinal,
    },
})
export default class ScorecardLeaderboard extends Vue {
    public fname = fname
    public expanded = false
    public topRanks: ILeaderboardResult[] = []

    @Getter public tsNpsSummary?: TsNpsSummaryEntity
    @Getter public scorecard!: ScorecardEntity
    @Getter public companyNpsSummary!: INPSSummary

    @Action public loadScorecard
    @Action public loadTsNpsSummary
    @Action public loadCompanyNpsSummary

    public mounted() {
        this.load()
    }

    public async load() {
        if (!this.scorecard) {
            await this.loadScorecard()
        }

        if (!this.companyNpsSummary.total) {
            await this.loadCompanyNpsSummary()
        }

        this.topRanks = this.scorecard.ranks.slice(0, 3)
    }

    public getAvatar(row: ILeaderboardResult) {
        return this.scorecard.avatars[row.name] || ''
    }

    public get minValue() {
        return Math.min(
            ...this.scorecard.ranks
                .filter((rank) => rank.responded >= 5)
                .map((rank) => rank.nps)
        )
    }

    public get maxValue() {
        return Math.max(
            ...this.scorecard.ranks
                .filter((rank) => rank.responded >= 5)
                .map((rank) => rank.nps)
        )
    }

    public get companyNps() {
        return Number(this.companyNpsSummary?.nps).toFixed(1)
    }

    public get scorecardRanks() {
        if (this.expanded) {
            return this.scorecard.ranks
        } else {
            return this.topRanks
        }
    }

    public get rankValues() {
        if (!this.scorecard) {
            return []
        }
        return this.scorecard.rankValues.filter((rank) => rank > 0).slice(0, 6)
    }
}
